import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {UtilsService} from '../../../../core/utils/utils.service';

@Component({
    selector: 'yo-img-entity',
    templateUrl: './img-entity.component.html',
    styleUrls: ['./img-entity.component.scss'],
    standalone: false
})
export class ImgEntityComponent implements OnInit, OnChanges {

  noImageUrl: string = 'assets/images/no-image.png';

  /** Entrées dont dépend l'URL du document : toute modification de l'une d'elles impose un recalcul. */
  URL_INPUT_LIST: string[] = ['entityName', 'entityId', 'ordre', 'format', 'refresh', 'displayNoImage'];

  @Input() entityId: number;
  @Input() entityName: string;
  @Input() ordre: number;
  @Input() height: number;
  @Input() title: string;
  @Input() format: string; // logo, thumb, regular, full
  @Input() openable: boolean = false;

  /**
   * Notifie le parent que l'image n'a pas pu être chargée. Sans cette sortie, les gabarits qui écoutent déjà
   * (onError) ne recevaient jamais rien : Angular posait un simple écouteur DOM sur l'hôte, jamais déclenché.
   */
  @Output() onError = new EventEmitter<boolean>();

  /**
   * Les entrées ci-dessous ne font que mémoriser leur valeur : le recalcul de l'URL est centralisé dans
   * ngOnChanges, qui reçoit aussi leurs changements sous leur nom public.
   */
  @Input() set refresh(value: number) {
    this._refresh = value;
  }

  // afficher l'image qui permet de dire qu'il n'y a pas d'image disponible
  @Input() set displayNoImage(value: boolean) {
    this._displayNoImage = value;
  }

  _refresh: number = 1;
  _displayNoImage: boolean;

  formats: Map<string, number>;
  url: string;
  isError: boolean;
  displayOriginalImg: boolean = false;

  urlOriginal: string;
  widthFull: number;

  private urlBuilt: boolean = false;


  constructor(public utils: UtilsService) {
  }

  /**
   * Point d'entrée unique du calcul de l'URL : ngOnChanges voit toutes les entrées, y compris au premier cycle,
   * donc un seul recalcul suffit là où le setter refresh, ngOnChanges et ngOnInit en déclenchaient trois — soit
   * jusqu'à trois requêtes au premier rendu.
   *
   * L'URL n'était auparavant construite qu'au ngOnInit et dans le setter refresh : quand entityName ou entityId
   * arrivait après le premier cycle — ou changeait, comme lors de la reconstruction du formulaire après un
   * enregistrement — le composant restait bloqué sur l'image « aucune image ».
   */
  ngOnChanges(changes: SimpleChanges) {
    if (this.URL_INPUT_LIST.some(input => changes[input])) {
      this.buildUrl();
    }
  }

  ngOnInit() {
    if (!this.urlBuilt) {
      this.buildUrl();
    }

    this.formats = new Map();
    this.formats.set('logo', 64);
    this.formats.set('thumb', 128);
    this.formats.set('regular', 800);
    this.formats.set('full', 2048);

    // this.width = this.formats.get(this.format);

  }

  /**
   * Construit l'URL du document à afficher. On repart systématiquement d'un isError à false : sinon un composant
   * réutilisé gardait l'image précédente, et un isError resté à true couplé à displayNoImage ne laissait aucune
   * branche du gabarit affichable.
   */
  private buildUrl() {
    this.urlBuilt = true;
    this.isError = false;

    if (this.utils.isNullOrEmpty(this.entityName)) {
      // sans entityName il n'y a rien à demander au back
      this.url = this._displayNoImage ? this.noImageUrl : '';
      return;
    }

    const entityName = this.entityName.toLowerCase();
    this.url = `dolrest/document/loadByEntity/${entityName}/${this.entityId}/${this.ordre}/${this.format}?date=${this._refresh}`;
  }

  getTooltip() {
    return this.isError ? 'Aucune image paramétrée' : '';
  }

  displayOriginalImage() {
    this.displayOriginalImg = !this.displayOriginalImg;

    this.urlOriginal = `dolrest/document/loadByEntity/${this.entityName}/${this.entityId}/${this.ordre}/original?date=${this._refresh}`;
  }

  closeDialog() {
    this.displayOriginalImg = false;
  }

  /**
   * Échec de chargement de l'image en taille réelle. On referme la fenêtre sans toucher à isError : la vignette est
   * un document distinct, correctement chargé, et ne doit pas disparaître avec.
   */
  onOriginalImageError() {
    this.displayOriginalImg = false;
  }

  onImageError() {
    if (this.isError) {
      return;
    }
    this.isError = true;
    this.url = this.noImageUrl;
    this.onError.emit(true);
  }

  onImageLoad(): void {
  }
}
